<template>
  <div class="portal-picker">
    <label for="landlord-select">Välj vart du ska</label>

    <select
      id="landlord-select"
      v-model="selected"
      :disabled="loading || !!error"
      @keyup.enter="go"
    >
      <option disabled value="">
        {{ loading ? 'Laddar…' : 'Välj din hyresvärd...' }}
      </option>
      <option v-for="item in items" :key="item.id" :value="item.subdomain">
        {{ item.name }}
      </option>
    </select>

    <BaseButton v-if="selected" type="button" :is-fullwidth="true" @click="go"
      ><BaseIconText :icon-url="svgs.ICONS.ARROW_RIGHT" :align-right="true">
        Gå vidare till {{ selectedName }}
      </BaseIconText>
    </BaseButton>
    <p v-if="error" class="error">Kunde inte ladda lista: {{ error }}</p>
  </div>
</template>

<script>
import applicationService from '@/services/applicationService';
import svgs from '@/utils/icon-constants';

import BaseButton from '@/components/BaseButton.vue';

export default {
  name: 'PortalPicker',
  components: {
    BaseButton
  },
  props: {
    applicationType: {
      type: String,
      required: true
    },
    host: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      selected: '',
      items: [],
      loading: false,
      error: '',
      svgs
    };
  },
  computed: {
    selectedName() {
      const sel = this.items.find(x => x.subdomain === this.selected);
      return sel ? sel.name : '';
    }
  },
  created() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.loading = true;
      this.error = '';
      try {
        const items = await applicationService.listLandlords(
          this.applicationType
        );
        this.items = items;
        this.items.sort((a, b) => a.name.localeCompare(b.name, 'sv'));
      } catch (e) {
        this.error = e.message || String(e);
      } finally {
        this.loading = false;
      }
    },

    go() {
      if (!this.selected) {
        return;
      }
      const url = `https://${this.selected}.${this.host}/logga-in`;
      window.location.assign(url);
    },

    guessRootDomain(hostname) {
      // "portal.example.com" -> "example.com"
      // "example.com" -> "example.com"
      // Obs: hanterar inte public suffix som "co.uk" – sätt då rootDomain-prop.
      const parts = hostname.split('.');
      if (parts.length <= 2) return hostname;
      return parts.slice(-2).join('.');
    }
  }
};
</script>

<style scoped>
.portal-picker {
  max-width: 100%;
  margin: 2rem auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: white;
  box-shadow: 0px 2px 15px rgba(0, 0, 0, 0.05);
  border-radius: 10px;
  padding: 1.4rem 2rem 2rem;
  gap: 1rem;
}
label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 600;
}

select {
  flex: 1;
  padding: 0.5rem 0.6rem;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  background: #fff;
  width: 100%;
}

.error {
  color: #b91c1c;
  margin-top: 0.5rem;
}
</style>
